import React, { useMemo } from 'react'
import { Provider } from 'react-redux'
import { PreloadedState } from 'redux'

import makeFlowInitialState from 'modules/flow/state/utils/flow-utils'
import { Config } from 'modules/config/state/config-types'
import { URLParams } from 'modules/url-params/state/app-url-params-types'
import { RootState, initializeStore } from 'redux/store'
import { makeOrderInitialState } from 'modules/order/state/order/order-utils'
import { makeStatusInitialState } from 'modules/status/state/status-utils'

export interface ReduxProviderProps {
  children: React.ReactNode
  urlParams: URLParams
  config: Config
}

const ReduxProvider = ({ children, urlParams, config }: ReduxProviderProps) => {
  const order = makeOrderInitialState(config, urlParams)
  const flow = makeFlowInitialState(config, urlParams)
  const status = makeStatusInitialState()
  const drawer = null
  const modal = null

  const preloadedState: PreloadedState<RootState> = {
    order,
    flow,
    drawer,
    modal,
    config,
    status,
    urlParams,
  }

  const store = useMemo(() => initializeStore(preloadedState), [])

  return <Provider store={store}>{children}</Provider>
}

export default ReduxProvider
